module.exports = __webpack_public_path__ + "static/base-9e5537937fc872d70c530acdf3bb414a.png";